module.exports = __webpack_public_path__ + "static/media/order_zone_inactive.9b04c445.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_zone_inactive.png
// module id = 1654
// module chunks = 0